import { IMonThiActionTypes } from "../../action-types/tct/IMonThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMonThiReducer } from "../../reducer-model/tct/IMonThiReducer";
const iniState: IMonThiReducer = {
  dotThiIdSelected: 0
};
export const monThiReducer = (state: IMonThiReducer = iniState, action: IMonThiActionTypes): IMonThiReducer => {
  const dotThiId = action.payload?.dotThiId ?? 0;
  switch (action.type) {
    case "MON_THI_CHANGE_DOT_THI_ID":
      return {
        ...state,
        dotThiIdSelected: dotThiId

      };
    case "MON_THI_LOAD_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_loading,
          selectedIds: []
        }
      };
    case "MON_THI_LOAD_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
          monThis: action.payload.data
        }
      };
    case "MON_THI_LOAD_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "MON_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          monThiEditing: action.payload.data,
          isShowEditModal: true
        }
      };
    case "MON_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          monThiEditing: undefined,
          isShowEditModal: false
        }
      };
    case "MON_THI_SAVE_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "MON_THI_SAVE_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
          isShowEditModal: false
        }
      };
    case "MON_THI_SAVE_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "MON_THI_DELETE_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_deleting,
        }
      };
    case "MON_THI_DELETE_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
          monHocIdsSelected: [],
          selectedIds: [],
          monHocIdFocused: 0
        }
      };
    case "MON_THI_DELETE_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "MON_THI_SHOW_ADD_MONTHI_MODAL":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          isShowAddMonThiModal: true,
          monHocIdReplace: action.payload.data
        }
      };
    case "MON_THI_CLOSE_ADD_MONTHI_MODAL":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          isShowAddMonThiModal: false,

        }
      };
    case "MON_THI_ADD_LOP_TIN_CHI_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,

        }
      };
    case "MON_THI_ADD_LOP_TIN_CHI_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
          isShowAddMonThiModal: false
        }
      };
    case "MON_THI_ADD_LOP_TIN_CHI_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed
        }
      };
    case "MON_THI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          selectedIds: action.payload.data
        }
      };
    case "MON_THI_CHANGE_MONHOC_ID_FOCUSED":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          monHocIdFocused: action.payload.data
        }
      };
    case "MON_THI_CHANGE_MONHOC_IDS_SELECTED":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          monHocIdsSelected: action.payload.data,
          selectedIds: []
        }
      };
    case "MON_THI_UPDATES_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "MON_THI_UPDATES_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
          selectedIds: []
        }
      };
    case "MON_THI_UPDATES_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "MON_THI_ADD_MON_THI_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "MON_THI_ADD_MON_THI_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "MON_THI_ADD_MON_THI_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "MON_THI_SYS_HINH_THUC_THI_START":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_saving,
        }
      };
    case "MON_THI_SYS_HINH_THUC_THI_SUCCESS":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_need_reload,
        }
      };
    case "MON_THI_SYS_HINH_THUC_THI_ERROR":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          status: eReducerStatusBase.is_completed,
        }
      };
    case "MON_THI_CHANGE_FILTER":
      return {
        ...state,
        [dotThiId]: {
          ...state[dotThiId],
          filter: action.payload.data
        }
      };
    default:
      return state;
  }
};
